import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from 'react-datepicker2';

export default class ReportSaleStuffsDetail extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report/sale',
            data: null,
            loading: true,
            systemModuleId: 5,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 187
        };
        this.state.filters = {
            status: 0,
            type: 0,
            sortBy: 0,
            fromNumber: '',
            toNumber: '',
            fromPrice: '',
            toPrice: '',
            fromDate: '',
            toDate: '',
            fromDateConverted: '',
            toDateConverted: ''
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گزارش جزئیات فروش کالاها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} مورد یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-success"><p>مجموع ریالی: {this.money(this.state.data.sumTotal)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-warning"><p>مجموع مقداری: {this.money(this.FixedPointNumber(this.state.data.sumCount,2))}</p></div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            {!this.state.isTemplate && <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان کالا/خدمت" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه وضعیتها</option>
                                                    <option value="1">پیش نویس</option>
                                                    <option value="2">نهایی</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.type} onChange={e => this.state.filters.type = e.target.value} className='form-control'>
                                                    <option value="0">همه انواع</option>
                                                    <option value="1">کالا</option>
                                                    <option value="2">خدمت</option>
                                                    <option value="3">محصول</option>
                                                    <option value="4">ماده اولیه</option>
                                                    <option value="5">دارایی ثابت</option>
                                                    <option value="6">ابزار مصرفی</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.sortBy} onChange={e => this.state.filters.sortBy = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">نمایش بر اساس عنوان (صعودی)</option>
                                                    <option value="1">نمایش بر اساس عنوان (نزولی)</option>
                                                    <option value="2">نمایش بر اساس فی (نزولی)</option>
                                                    <option value="3">نمایش بر اساس فی (صعودی)</option>
                                                    <option value="4">نمایش بر اساس مقدار (نزولی)</option>
                                                    <option value="5">نمایش بر اساس مقدار (صعودی)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-inline flex-nowrap gx-3 mt-2">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.fromNumber} onChange={e => this.state.filters.fromNumber = e.target.value} placeholder="از شماره فاکتور" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.toNumber} onChange={e => this.state.filters.toNumber = e.target.value} placeholder="تا شماره فاکتور" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.fromPrice} onChange={e => this.state.filters.fromPrice = e.target.value} placeholder="از فی فاکتور" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.toPrice} onChange={e => this.state.filters.toPrice = e.target.value} placeholder="تا فی فاکتور" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.fromDate = e;
                                                        this.state.filters.fromDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.toDate = e;
                                                        this.state.filters.toDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.toDate)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>}
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ موردی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">طرف حساب</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره فاکتور</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ فاکتور</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تعداد/مقدار</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">واحد سنجش</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">فی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.stuffName}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        {record.personName}
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.factorNumber}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.factorDate}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(this.FixedPointNumber(record.count,2))}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.unitName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.price)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}